/** @jsxImportSource minimal-view */

import { render, enableDebug, effect } from 'minimal-view'

effect.maxUpdates = 200_000

import { App } from '../../web/app'

render(<App />, document.body)
